module.exports = __webpack_public_path__ + "static/media/exclamation.7b101e27.svg";